export const landingFeatures: string[] = [
  "features.landing.feature1",
  "features.landing.feature2",
  "features.landing.feature3",
  "features.landing.feature4",
];

export const ibanInquiryFeatures: string[] = [
  "features.ibanInquiry.feature1",
  "features.ibanInquiry.feature2",
  "features.ibanInquiry.feature3",
];
export const cardToIbanFeatures: string[] = [
  "features.cardToIban.feature1",
  "features.cardToIban.feature2",
  "features.cardToIban.feature3",
];
export const accountToIbanFeatures: string[] = [
  "features.accountToIban.feature1",
  "features.accountToIban.feature2",
  "features.accountToIban.feature3",
];
export const cardInquiryFeatures: string[] = [
  "features.cardInquiry.feature1",
  "features.cardInquiry.feature2",
  "features.cardInquiry.feature3",
];
export const cardToAccountFeatures: string[] = [
  "features.cardToAccount.feature1",
  "features.cardToAccount.feature2",
  "features.cardToAccount.feature3",
];
export const bouncedCheckFeatures: string[] = [
  "features.bouncedCheck.feature1",
  "features.bouncedCheck.feature2",
  "features.bouncedCheck.feature3",
  "features.bouncedCheck.feature4",
];
export const militaryServiceStatusFeatures: string[] = [
  "features.militaryServiceStatus.feature1",
  "features.militaryServiceStatus.feature2",
  "features.militaryServiceStatus.feature3",
  "features.militaryServiceStatus.feature4",
];
export const postalCodeInquiryFeatures: string[] = [
  "features.postalCodeInquiry.feature1",
  "features.postalCodeInquiry.feature2",
  "features.postalCodeInquiry.feature3",
];
export const companyInformationInquiryFeatures: string[] = [
  "features.companyInformationInquiry.feature1",
  "features.companyInformationInquiry.feature2",
  "features.companyInformationInquiry.feature3",
  "features.companyInformationInquiry.feature4",
];

export const companyMembersInquiryFeatures: string[] = [
  "features.companyMembersInquiry.feature1",
  "features.companyMembersInquiry.feature2",
  "features.companyMembersInquiry.feature3",
  "features.companyMembersInquiry.feature4",
];

export const companyLicensesInquiryFeatures: string[] = [
  "features.companyLicensesInquiry.feature1",
  "features.companyLicensesInquiry.feature2",
  "features.companyLicensesInquiry.feature3",
  "features.companyLicensesInquiry.feature4",
];

export const companyParentsInquiryFeatures: string[] = [
  "features.companyParentsInquiry.feature1",
  "features.companyParentsInquiry.feature2",
  "features.companyParentsInquiry.feature3",
  "features.companyParentsInquiry.feature4",
];

export const companyChildrenInquiryFeatures: string[] = [
  "features.companyChildrenInquiry.feature1",
  "features.companyChildrenInquiry.feature2",
  "features.companyChildrenInquiry.feature3",
  "features.companyChildrenInquiry.feature4",
];

export const walletFeatures: string[] = [
  "features.wallet.feature1",
  "features.wallet.feature2",
  "features.wallet.feature3",
];

export const khalafiInquiryFeatures: string[] = [
  "features.khalafiInquiry.feature1",
  "features.khalafiInquiry.feature2",
  "features.khalafiInquiry.feature3",
];

export const finesPhotoInquiryFeatures: string[] = [
  "features.finesPhotoInquiry.feature1",
  "features.finesPhotoInquiry.feature2",
  "features.finesPhotoInquiry.feature3",
];

export const motorcycleFinesInquiryFeatures: string[] = [
  "features.motorcycleFinesInquiry.feature1",
  "features.motorcycleFinesInquiry.feature2",
  "features.motorcycleFinesInquiry.feature3",
  "features.motorcycleFinesInquiry.feature4",
];

export const convertMoneyInquiryFeatures: string[] = [
  "features.moneyConvertor.feature1",
  "features.moneyConvertor.feature2",
  "features.moneyConvertor.feature3",
];

export const estelamPelakInquiryFeatures: string[] = [
  "features.estelamPelak.feature1",
  "features.estelamPelak.feature2",
  "features.estelamPelak.feature3",
];

export const negativePointsInquiryFeatures: string[] = [
  "features.negativePoints.feature1",
  "features.negativePoints.feature2",
  "features.negativePoints.feature3",
];

export const passportStatusInquiryFeatures: string[] = [
  "features.passportStatus.feature1",
  "features.passportStatus.feature2",
  "features.passportStatus.feature3",
];

export const plateInquiryFeatures: string[] = [
  "features.plateInquiry.feature1",
  "features.plateInquiry.feature2",
  "features.plateInquiry.feature3",
];

export const sanaInquiryFeatures: string[] = [
  "features.sanaInquiry.feature1",
  "features.sanaInquiry.feature2",
  "features.sanaInquiry.feature3",
];

export const identityInquiryFeatures: string[] = [
  "features.identityInquiry.feature1",
  "features.identityInquiry.feature2",
  "features.identityInquiry.feature3",
  "features.identityInquiry.feature4",
];

export const bankValidationFeatures: string[] = [
  "features.bankValidation.feature1",
  "features.bankValidation.feature2",
  "features.bankValidation.feature3",
];

export const foreignersFeatures: string[] = [
  "features.foreignersInquiry.feature1",
  "features.foreignersInquiry.feature2",
  "features.foreignersInquiry.feature3",
  "features.foreignersInquiry.feature4",
];

export const corporateIdentityFeatures: string[] = [
  "features.corporateIdentity.feature1",
  "features.corporateIdentity.feature2",
  "features.corporateIdentity.feature3",
];

export const carDocumentFeatures: string[] = [
  "features.carDocument.feature1",
  "features.carDocument.feature2",
  "features.carDocument.feature3",
];

export const chequeFeatures: string[] = [
  "features.chequeInquiry.feature1",
  "features.chequeInquiry.feature2",
  "features.chequeInquiry.feature3",
];

export const chequeV2Features: string[] = [
  "features.chequeV2Inquiry.feature1",
  "features.chequeV2Inquiry.feature2",
  "features.chequeV2Inquiry.feature3",
  "features.chequeV2Inquiry.feature4",
  "features.chequeV2Inquiry.feature5",
];

export const transferChainFeatures: string[] = [
  "features.transferChainInquiry.feature1",
  "features.transferChainInquiry.feature2",
  "features.transferChainInquiry.feature3",
  "features.transferChainInquiry.feature4",
];

export const postalTrackingFeatures: string[] = [
  "features.postalTracking.feature1",
  "features.postalTracking.feature2",
  "features.postalTracking.feature3",
  "features.postalTracking.feature4",
];

export const companyNewspaperInquiryFeatures: string[] = [
  "features.companyNewspaperInquiry.feature1",
  "features.companyNewspaperInquiry.feature2",
  "features.companyNewspaperInquiry.feature3",
  "features.companyNewspaperInquiry.feature4",
];

export const electricityBillInquiryFeatures: string[] = [
  "features.electricityBillInquiry.feature1",
  "features.electricityBillInquiry.feature2",
  "features.electricityBillInquiry.feature3",
  "features.electricityBillInquiry.feature4",
];

export const billsFeatures: string[] = [
  "features.billsFeatures.feature1",
  "features.billsFeatures.feature2",
  "features.billsFeatures.feature3",
];

export const electricityBillInfoInquiryFeatures: string[] = [
  "features.electricityBillInfoInquiry.feature1",
  "features.electricityBillInfoInquiry.feature2",
  "features.electricityBillInfoInquiry.feature3",
];

export const gasBillInquiryFeatures: string[] = [
  "features.gasBillInquiry.feature1",
  "features.gasBillInquiry.feature2",
  "features.gasBillInquiry.feature3",
  "features.gasBillInquiry.feature4",
];

export const gasBillInquiryInfoFeatures: string[] = [
  "features.gasBillInfoInquiry.feature1",
  "features.gasBillInfoInquiry.feature2",
  "features.gasBillInfoInquiry.feature3",
];

export const waterBillInquiryFeatures: string[] = [
  "features.waterBillInquiry.feature1",
  "features.waterBillInquiry.feature2",
  "features.waterBillInquiry.feature3",
  "features.waterBillInquiry.feature4",
];

export const waterBillInfoInquiryFeatures: string[] = [
  "features.waterBillInfoInquiry.feature1",
  "features.waterBillInfoInquiry.feature2",
  "features.waterBillInfoInquiry.feature3",
];

export const rightelBillInquiryFeatures: string[] = [
  "features.rightelBillInquiry.feature1",
  "features.rightelBillInquiry.feature2",
  "features.rightelBillInquiry.feature3",
  "features.rightelBillInquiry.feature4",
];

export const mtnBillInquiryFeatures: string[] = [
  "features.mtnBillInquiry.feature1",
  "features.mtnBillInquiry.feature2",
  "features.mtnBillInquiry.feature3",
  "features.mtnBillInquiry.feature4",
];

export const mciBillInquiryFeatures: string[] = [
  "features.mciBillInquiry.feature1",
  "features.mciBillInquiry.feature2",
  "features.mciBillInquiry.feature3",
  "features.mciBillInquiry.feature4",
];

export const phoneBillInquiryFeatures: string[] = [
  "features.phoneBillInquiry.feature1",
  "features.phoneBillInquiry.feature2",
  "features.phoneBillInquiry.feature3",
  "features.phoneBillInquiry.feature4",
];

export const phoneImageBillInquiryFeatures: string[] = [
  "features.phoneImageBillInquiry.feature1",
  "features.phoneImageBillInquiry.feature2",
  "features.phoneImageBillInquiry.feature3",
  "features.phoneImageBillInquiry.feature4",
];

export const electricityHistoryBillInquiryFeatures: string[] = [
  "features.electricityHistoryBillInquiry.feature1",
  "features.electricityHistoryBillInquiry.feature2",
  "features.electricityHistoryBillInquiry.feature3",
  "features.electricityHistoryBillInquiry.feature4",
];

export const electricityImageBillInquiryFeatures: string[] = [
  "features.electricityImageBillInquiry.feature1",
  "features.electricityImageBillInquiry.feature2",
  "features.electricityImageBillInquiry.feature3",
  "features.electricityImageBillInquiry.feature4",
];

export const gasHistoryBillInquiryFeatures: string[] = [
  "features.gasHistoryBillInquiry.feature1",
  "features.gasHistoryBillInquiry.feature2",
  "features.gasHistoryBillInquiry.feature3",
  "features.gasHistoryBillInquiry.feature4",
];

// برای استفاده در صفحه نتیجه استعلام
export const FEATURES_MAP: Record<number, string[]> = {
  1: cardInquiryFeatures,
  2: ibanInquiryFeatures,
  3: cardToAccountFeatures,
  4: cardToIbanFeatures,
  5: accountToIbanFeatures,
  6: bouncedCheckFeatures,
  7: bankValidationFeatures,
  10: khalafiInquiryFeatures,
  12: plateInquiryFeatures,
  13: militaryServiceStatusFeatures,
  14: companyInformationInquiryFeatures,
  15: negativePointsInquiryFeatures,
  17: postalCodeInquiryFeatures,
  18: sanaInquiryFeatures,
  21: companyMembersInquiryFeatures,
  24: identityInquiryFeatures,
  25: militaryServiceStatusFeatures,
  26: militaryServiceStatusFeatures,
  28: motorcycleFinesInquiryFeatures,
  31: foreignersFeatures,
  33: companyLicensesInquiryFeatures,
  34: companyChildrenInquiryFeatures,
  35: companyParentsInquiryFeatures,
  36: corporateIdentityFeatures,
  44: finesPhotoInquiryFeatures,
  45: passportStatusInquiryFeatures,
  47: carDocumentFeatures,
  52: chequeFeatures,
  53: chequeV2Features,
  55: transferChainFeatures,
  56: companyNewspaperInquiryFeatures,
  57: postalTrackingFeatures,
  60: waterBillInquiryFeatures,
  61: gasBillInquiryFeatures,
  62: electricityBillInquiryFeatures,
  63: electricityBillInfoInquiryFeatures,
  64: waterBillInfoInquiryFeatures,
  65: gasBillInquiryInfoFeatures,
  67: phoneBillInquiryFeatures,
  68: mciBillInquiryFeatures,
  69: mtnBillInquiryFeatures,
  70: rightelBillInquiryFeatures,
  74: phoneImageBillInquiryFeatures,
  73: electricityHistoryBillInquiryFeatures,
  72: electricityImageBillInquiryFeatures,
  71: gasHistoryBillInquiryFeatures,
};
